// extracted by mini-css-extract-plugin
export default {"FinalSum":"bbeB52ub","box":"DhMVUZTf","description":"RN1iOLIe","icon":"P7EVRcBP","descriptionText":"OI4DyWfm","text":"STvSiQOx","sum":"Oh6UjQAP","forward":"rjrCt4GQ","speaker":"KIfiqsJp","speakerImg":"mQD6iGJk"};
    if(module.hot) {
      // 1717522985900
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  